/**
 * * Async JSON request
 * @param {null}
 * @returns {object} object containing all user and store data
 */
export async function getStoreVerification(
    user_id: string,
    concept_id: string
) {
    const url = `${process.env.REACT_APP_API_URL}/store_verification`;

    let body = JSON.stringify({
        action: 'get_stores',
        user_id: user_id,
        concept_id: concept_id,
    });

    return fetch(url, {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: body,
    })
        .then((response) => {
            if (!response.ok) {
                throw new Error(JSON.stringify(response.json()));
            }
            return response.json();
        })
        .catch((err) => {
            console.error(err);
            throw err;
        });
}
